// extracted by mini-css-extract-plugin
module.exports = {"container":"warning-popup-container__8-OaP","text":"warning-popup-text__2hdjJ","delete_button":"warning-popup-delete_button__3i-OZ","arrow":"warning-popup-arrow__1LIaQ"};